import React, { useState, useEffect } from "react";
import Navbar from "../../../../components/Navbar";
import SideBar from "../../../../components/SideBar";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import TimePicker from "react-bootstrap-time-picker";
import Select from "react-select";
import { Link, useParams } from "react-router-dom";
import { API_URL } from "../../../../constants";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from 'date-fns';
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";

const EditBranchMaster = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };


  const [formData, setFormData] = useState({
    Code: "",
    Name: "",
    Description: "",
    Address: "",
    ServiceCenterAddress: "",
    AddressCode: "",
    BranchMastersCode: "",
    BranchTXNCode: "",
    MobileNo1: "",
    MobileNo2: "",
    PhoneNo1: "",
    PhoneNo2: "",
    FaxNo: "",
    Email: "",
    Email_account: "",
    Website: "",
    CIN: "",
    PAN: "",
    TAN: "",
    MVAT: "",
    CST: "",
    ServiceTaxNo: "",
    LBT: "",
    GSTNo: "",
    StartDate: new Date(),
    ClosedDate: new Date(),
    GSTEffectiveDate: new Date(),
    StartTime: "",
    EndTime: "",
    AreaID: "",
    CityID: "",
    StateID: "",
    CountryID: "",
    ZipCode: "",
    DefaultVoucherType_136: "",
    ApplicableVoucherType_136: null,
    StoreManagerID: null,
    MasterTextAppendPosition_034: "",
    TXNTextAppendPosition_034: "",
    BranchType_051: null,
  });
  const [defaultoption, setDefaultOption] = useState([]);
  const [default1, setDefault1] = useState([]);
  const [storeManagerOpt, setStoreManagerOpt] = useState([]);
  const [masterTXNA, setMasterTXNA] = useState([]);
  const [txtTextAppend, settxtAppend] = useState([]);
  const [branchtyOpt, setbranchtyOpt] = useState([]);
  const [area, setArea] = useState([]);
  const [areas, setAreas] = useState([]);
  const [areaDetails, setAreaDetails] = useState({
    City: '',
    state: '',
    Country: '',
  });

  // code for option type
  const handleInputChange = (name, selectedOption) => {
    setFormData({
      ...formData,
      [name]: selectedOption,
    });
  };

  // code for normal input section and customdatepicker
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // fetch option using API
  const fetchTypeOptions = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-branch-master-dropdown`
      );
      // default and applicable voucher option
      const voucherType = response.data.default_voucher;
      const options = voucherType.map((voucher) => ({
        value: voucher.value,
        label: voucher.text,
      }));
      setDefaultOption(options);
      setDefault1(options);

      // store manager option
      const storeManager = response.data.store_manager;
      const manager = storeManager.map((store) => ({
        value: store.value,
        label: store.text,
      }));
      setStoreManagerOpt(manager);

      // master and TXN Append Option
      const masterTXN = response.data.txn_text_append_position;
      const mastxn = masterTXN.map((store) => ({
        value: store.value,
        label: store.text,
      }));
      setMasterTXNA(mastxn);
      settxtAppend(mastxn);

      // Branch Type
      const BranchType = response.data.branch_type;
      const branch = BranchType.map((store) => ({
        value: store.value,
        label: store.text,
      }));
      setbranchtyOpt(branch);
    } catch (error) {
      console.error("Error fetching JobType options:", error);
    }
  };
  useEffect(() => {
    fetchTypeOptions();
  }, []);

  const areaOptions = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}fetch-company-master-dropdown`
      );
      // area details
      const area = response.data.area;
      const areaoption = area.map((format) => ({
        value: format.value,
        label: format.text,
      }));
      setArea(areaoption);
    } catch (error) {
      console.error("Error fetching JobType options:", error);
    }
  };

  useEffect(() => {
    areaOptions();
  }, []);

  const handleTimeChange = (name, timeInSeconds) => {
    console.log(`timeInSeconds is here`);
    console.log(timeInSeconds);
    const hours = String(Math.floor(timeInSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((timeInSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const formattedTime = `${hours}:${minutes}:00`;
    setFormData({ ...formData, [name]: formattedTime });
  };

  const handleSelectChange = (selectedOption) => {
    console.log(`Selected: ${selectedOption.value}`);

    // Define the payload to send to the API
    const payload = {
      area_id: selectedOption.value,
    };

    // Make the POST request
    PostServiceCaller(`${API_URL}fetch-area-details`, payload, "post")
      .then((response) => {
        console.log("Data sent successfully:", response.data);
        const data = response.data.data;
        setAreaDetails({
            City: data.City,
            state: data.state,
            Country: data.Country,
          });
        setFormData({
          ...formData,
          CityID: { label: data.City, value: data.CityID },
          CountryID: { label: data.Country, value: data.CountryID },
          StateID: { label: data.state, value: data.StateID },
          AreaID: { label: selectedOption.label, value: selectedOption.value },
          ZipCode: data.ZipCode,
        });
        console.log(`form data is here`);
        console.log(formData);
      })
      .catch((error) => {
        console.error("There was an error sending the data:", error);
      });
  };

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);

  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}branch/${id}`);
      const default_voucherOpt = response.data.default_voucher.map(
        (option) => ({
          value: option.value,
          label: option.text,
        })
      );
      setDefault1(default_voucherOpt);
      setDefaultOption(default_voucherOpt);
      const store_manager = response.data.store_manager.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setStoreManagerOpt(store_manager);

      const branch_type = response.data.branch_type.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setbranchtyOpt(branch_type);

      const masterTextAppend = response.data.txn_text_append_position.map(
        (option) => ({
          value: option.value,
          label: option.text,
        })
      );
      setMasterTXNA(masterTextAppend);
      settxtAppend(masterTextAppend);

      const area = response.data.area.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setArea(area);
      
      const areaDetails = response.data.area_details;
      setAreaDetails(areaDetails);

      if (response.status === 200) {
        const data = response.data.data || {};
        const defaultVoucher = default_voucherOpt.find(
          (option) => option.value == data.DefaultVoucherType_136
        );
        const applicableVoucher = default_voucherOpt.find(
          (option) => option.value == data.ApplicableVoucherType_136
        );
        const storeManager = store_manager.find(
          (option) => option.value == data.StoreManagerID
        );
        const branchType = branch_type.find(
          (option) => option.value == data.BranchType_051
        );
        const masterTextApend = masterTextAppend.find(
          (option) => option.value == data.MasterTextAppendPosition_034
        );
        const txtTextApend = masterTextAppend.find(
          (option) => option.value == data.TXNTextAppendPosition_034
        );
        const Area = area.find((option) => option.value == data.AreaID);

        setFormData({
          id: id,
          Code: data.Code,
          Name: data.Name,
          Description: data.Description,
          Address: data.Address,
          ServiceCenterAddress: data.ServiceCenterAddress,
          AddressCode: data.AddressCode,
          BranchMastersCode: data.BranchMastersCode,
          BranchTXNCode: data.BranchTXNCode,
          MobileNo1: data.MobileNo1,
          MobileNo2: data.MobileNo2,
          PhoneNo1: data.PhoneNo1,
          PhoneNo2: data.PhoneNo2,
          FaxNo: data.FaxNo,
          Email: data.Email,
          Email_account: data.Email_account,
          Website: data.Website,
          CIN: data.CIN,
          PAN: data.PAN,
          TAN: data.TAN,
          GSTNo: data.GSTNo,
          MVAT: data.MVAT,
          CST: data.CST,
          ServiceTaxNo: data.ServiceTaxNo,
          LBT: data.LBT,
          StartDate: format(new Date(data.StartDate), 'dd-MM-yyyy'),
          ClosedDate: format(new Date(data.ClosedDate), 'dd-MM-yyyy'),
          GSTEffectiveDate: format(new Date(data.GSTEffectiveDate), 'dd-MM-yyyy'),
          StartTime: data.StartTime,
          EndTime: data.EndTime,
          AreaID: Area,
          CityID: areaDetails.City,
          ZipCode: data.ZipCode,
          DefaultVoucherType_136: defaultVoucher,
          ApplicableVoucherType_136: applicableVoucher,
          StoreManagerID: storeManager,
          MasterTextAppendPosition_034: masterTextApend,
          TXNTextAppendPosition_034: txtTextApend,
          BranchType_051: branchType,
        });
        console.log("Form data after setting:", setFormData);
      } else {
        console.error(
          "Failed to fetch course details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };




const handleEdit = async (e) => {
    e.preventDefault();

    console.log("Form data before submission:", formData);

    const submitData = {
        ...formData,
        CityID: formData.CityID ? formData.CityID.value : "",
        StateID: formData.StateID ? formData.StateID.value : "",
        CountryID: formData.CountryID ? formData.CountryID.value : "",
        AreaID: formData.AreaID ? formData.AreaID : "", 
    };

    console.log("Check Submit data", submitData);

    try {
        // Ensure formData has an id for updating
        if (!formData.id) {
            throw new Error("Cannot update without an ID.");
        }

        const response = await PostServiceCaller(
            `${API_URL}branch/${formData.id}`,
            submitData,
            "put"
        );

        toast.success("Form Update successfully!");
        console.log("Form Update successfully", response);
        setTimeout(() => {
          navigate('/branchmastertable'); 
        }, 2000); 
    } catch (error) {
        toast.error("Form Not Submitted!");
        console.error("There was an error submitting the form!", error);
    }
};

  return (
    <>
      <div className="Nav">
        <Navbar />
      </div>
      <div className="nest-page">
        <SideBar />
        <div className="Container" id="form-input-section">
          <div className="mx-3">
            <h3 className="heading skill-heading">
              <i className="fa fa-bookmark"></i>Branch Master
            </h3>
          </div>
          <form
            id="formOne"
            onSubmit={handleEdit}
            className="rounded bg-white"
          >
            <section className="bsb-accordion-6">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="accordion" id="accordionExample">
                      <div className="accordion-item">
                        <h5 className="accordion-header" id="accordion-header">
                          <div
                            className={`d-flex pt-2 ${
                              activeIndex !== 0 ? "collapsed" : ""
                            }`}
                            // type="button"
                            data-bs-toggle="collapse"
                            onClick={() => toggleAccordion(0)}
                            aria-expanded={activeIndex === 0}
                            aria-controls="collapseOne"
                          >
                            <i
                              className={`me-2 bi ${
                                activeIndex === 0 ? "bi-dash" : "bi-plus"
                              }`}
                            ></i>
                            <h5>General & Additional Details</h5>
                          </div>
                        </h5>
                        <div
                          id="collapseOne"
                          className={`accordion-collapse collapse ${
                            activeIndex === 0 ? "show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="container">
                              <div className="row row-flex">
                                {/* grid one */}
                                <div className="col-md-6 flex-col mt-1">
                                  <div class="card">
                                    <div className="card-body">
                                      <div class="row">
                                        <div class="col-6">
                                          <div class="form-group">
                                            <label className="col-form-label lbl me-2">
                                              <strong>Code</strong>
                                            </label>
                                            <input
                                              type="text"
                                              name="Code"
                                              placeholder="Code"
                                              className="form-control"
                                              value={formData.Code}
                                            />
                                          </div>
                                        </div>
                                        <div class="col-6">
                                          <div class="form-group">
                                            <label className="col-form-label lbl me-2">
                                              <strong>Name</strong>
                                            </label>
                                            <input
                                              type="text"
                                              name="Name"
                                              value={formData.Name}
                                              onChange={handleChange}
                                              placeholder="Name"
                                              className="form-control"
                                            />
                                          </div>
                                        </div>
                                        <div class="col-6">
                                          <div class="form-group">
                                            <label className="col-form-label lbl me-3">
                                              <strong>Description</strong>
                                            </label>
                                            <textarea
                                              type="text"
                                              placeholder="Description"
                                              value={formData.Description}
                                              onChange={handleChange}
                                              className="form-control"
                                              id="Description"
                                              name="Description"
                                            ></textarea>
                                          </div>
                                        </div>
                                        <div class="col-6">
                                          <div class="form-group">
                                            <label className="col-form-label lbl me-3">
                                              <strong>Company</strong>
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                            />
                                            {/* <Select onChange={(selected) => { handleDropdownChange(selected, 'hr') }} value={formData.hr} name="hr" options={hrOptions} /> */}
                                          </div>
                                        </div>
                                        <div class="col-6">
                                          <div class="form-group">
                                            <label className="col-form-label lbl me-2">
                                              <strong>Start Date</strong>
                                            </label>
                                            <CustomDatePicker
                                              name="StartDate"
                                              handleChange={handleChange}
                                              value={formData.StartDate}
                                              placeholderText="Start Date"
                                            ></CustomDatePicker>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className="form-group">
                                            <label className="col-form-label lbl me-2">
                                              <strong>Close Date</strong>
                                            </label>
                                            <CustomDatePicker
                                              name="ClosedDate"
                                              handleChange={handleChange}
                                              value={formData.ClosedDate}
                                              placeholderText="Close Date"
                                            ></CustomDatePicker>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className="form-group">
                                            <label className="col-form-label lbl me-2">
                                              <strong>Start Time</strong>
                                            </label>
                                            <TimePicker
                                              value={
                                                formData.StartTime
                                                  ? parseInt(
                                                      formData.StartTime.split(
                                                        ":"
                                                      )[0]
                                                    ) *
                                                      3600 +
                                                    parseInt(
                                                      formData.StartTime.split(
                                                        ":"
                                                      )[1]
                                                    ) *
                                                      60
                                                  : 0
                                              }
                                              start="10:00"
                                              end="19:00"
                                              step={30}
                                              onChange={(time) =>
                                                handleTimeChange(
                                                  "StartTime",
                                                  time
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className="form-group">
                                            <label className="col-form-label lbl me-2">
                                              <strong>End Time</strong>
                                            </label>
                                            <TimePicker
                                              value={
                                                formData.EndTime
                                                  ? parseInt(
                                                      formData.EndTime.split(
                                                        ":"
                                                      )[0]
                                                    ) *
                                                      3600 +
                                                    parseInt(
                                                      formData.StartTime.split(
                                                        ":"
                                                      )[1]
                                                    ) *
                                                      60
                                                  : 0
                                              }
                                              start="10:00"
                                              end="19:00"
                                              step={30}
                                              onChange={(time) =>
                                                handleTimeChange(
                                                  "EndTime",
                                                  time
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* grid two */}
                                <div className="col-md-6 flex-col mt-1">
                                  <div className="card">
                                    <div className="card-body">
                                      <div className="row">
                                        <div className="col-6">
                                          <div>
                                            <label className="col-form-label lbl me-2">
                                              <strong>
                                                Default Voucher Type
                                              </strong>
                                            </label>
                                            <Select
                                              value={
                                                formData.DefaultVoucherType_136
                                              }
                                              options={default1}
                                              name="DefaultVoucherType_136"
                                              onChange={(selectedOption) =>
                                                handleInputChange(
                                                  "DefaultVoucherType_136",
                                                  selectedOption
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div>
                                            <label className="col-form-label lbl me-2">
                                              <strong>Appl Voucher Type</strong>
                                            </label>
                                            <Select
                                              value={
                                                formData.ApplicableVoucherType_136
                                              }
                                              options={defaultoption}
                                              name="ApplicableVoucherType_136"
                                              onChange={(selectedOption) =>
                                                handleInputChange(
                                                  "ApplicableVoucherType_136",
                                                  selectedOption
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div>
                                            <label className="col-form-label lbl me-3">
                                              <strong>Store Manager</strong>
                                            </label>
                                            <Select
                                              value={formData.StoreManagerID}
                                              options={storeManagerOpt}
                                              name="StoreManagerID"
                                              onChange={(selectedOption) =>
                                                handleInputChange(
                                                  "StoreManagerID",
                                                  selectedOption
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Area and Branch Code Details */}
                      <div className="accordion-item">
                        <h5 className="accordion-header">
                          <div
                            className={`d-flex pt-2 ${
                              activeIndex !== 1 ? "collapsed" : ""
                            }`}
                            // type="button"
                            data-bs-toggle="collapse"
                            onClick={() => toggleAccordion(1)}
                            aria-expanded={activeIndex === 1}
                            aria-controls="collapseTwo"
                          >
                            <i
                              className={`me-2 bi ${
                                activeIndex === 1 ? "bi-dash" : "bi-plus"
                              }`}
                            ></i>
                            <h5>Area Details & Branch Code Settings</h5>
                          </div>
                        </h5>
                        <div
                          id="collapseTwo"
                          className={`accordion-collapse collapse ${
                            activeIndex === 1 ? "show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              {/* grid one */}
                              <div className="col-md-6 flex-col mt-1">
                                <div class="card">
                                  <div className="card-body">
                                    <div class="row">
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>Address</strong>
                                          </label>
                                          <textarea
                                            type="text"
                                            name="Address"
                                            onChange={handleChange}
                                            value={formData.Address}
                                            className="form-control"
                                          ></textarea>
                                        </div>
                                      </div>
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>Address Code</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="AddressCode"
                                            value={formData.AddressCode}
                                            onChange={handleChange}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>
                                              Service Center Address
                                            </strong>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              formData.ServiceCenterAddress
                                            }
                                            onChange={handleChange}
                                            id="ServiceCenterAddress"
                                            name="ServiceCenterAddress"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div>
                                          <label className="col-form-label lbl me-2">
                                            <strong>Area</strong>
                                          </label>
                                          <Select
                                            options={area}
                                            onChange={handleSelectChange}
                                            value={formData.AreaID}
                                            name="AreaID"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>City</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="CityID"
                                            onChange={handleChange}
                                            className="form-control"
                                            placeholder="City"
                                            value={areaDetails.CityID || formData.CityID?.label}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>State</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="StateID"
                                            className="form-control"
                                            placeholder="State"
                                            // value={
                                            //   formData.StateID?.label || ""
                                            // }
                                            value={areaDetails.state || formData.StateID?.label}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>Country</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="CountryID"
                                            className="form-control"
                                            placeholder="Country"
                                            // value={
                                            //   formData.CountryID?.label || ""
                                            // }
                                            value={
                                              areaDetails.Country ||
                                              formData.CountryID?.label
                                            }
                                          />
                                        </div>
                                      </div>

                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>Zip Code</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="ZipCode"
                                            className="form-control"
                                            placeholder="Zip Code"
                                            value={formData.ZipCode}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* grid two */}
                              <div className="col-md-6 flex-col mt-1">
                                <div class="card">
                                  <div className="card-body">
                                    <div class="row">
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>Branch Masters Code</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="BranchMastersCode"
                                            value={formData.BranchMastersCode}
                                            onChange={handleChange}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-6">
                                        <div>
                                          <label className="col-form-label lbl me-2">
                                            <strong>
                                              Master Text Append Position
                                            </strong>
                                          </label>
                                          <Select
                                            value={
                                              formData.MasterTextAppendPosition_034
                                            }
                                            options={masterTXNA}
                                            name="MasterTextAppendPosition_034"
                                            onChange={(selectedOption) =>
                                              handleInputChange(
                                                "MasterTextAppendPosition_034",
                                                selectedOption
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>Branch TXN Code</strong>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            onChange={handleChange}
                                            value={formData.BranchTXNCode}
                                            id="BranchTXNCode"
                                            name="BranchTXNCode"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div>
                                          <label className="col-form-label lbl me-2">
                                            <strong>
                                              TXN Text Append Position
                                            </strong>
                                          </label>
                                          <Select
                                            value={
                                              formData.TXNTextAppendPosition_034
                                            }
                                            options={masterTXNA}
                                            name="TXNTextAppendPosition_034"
                                            onChange={(selectedOption) =>
                                              handleInputChange(
                                                "TXNTextAppendPosition_034",
                                                selectedOption
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div>
                                          <label className="col-form-label lbl me-2">
                                            <strong>Branch Type</strong>
                                          </label>
                                          <Select
                                            value={formData.BranchType_051}
                                            options={branchtyOpt}
                                            name="BranchType_051"
                                            onChange={(selectedOption) =>
                                              handleInputChange(
                                                "BranchType_051",
                                                selectedOption
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Communication and Tax Details */}
                      <div className="accordion-item">
                        <h5 className="accordion-header">
                          <div
                            className={`d-flex pt-2 ${
                              activeIndex !== 2 ? "collapsed" : ""
                            }`}
                            // type="button"
                            data-bs-toggle="collapse"
                            onClick={() => toggleAccordion(2)}
                            aria-expanded={activeIndex === 2}
                            aria-controls="collapseThree"
                          >
                            <i
                              className={`me-2 bi ${
                                activeIndex === 2 ? "bi-dash" : "bi-plus"
                              }`}
                            ></i>
                            <h5>Communication & Tax Details</h5>
                          </div>
                        </h5>
                        <div
                          id="collapseThree"
                          className={`accordion-collapse collapse ${
                            activeIndex === 2 ? "show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              {/* grid one */}
                              <div className="col-md-6 flex-col mt-1">
                                <div class="card">
                                  <div className="card-body">
                                    <div class="row">
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>Mobile #1</strong>
                                          </label>
                                          <input
                                            type="number"
                                            name="MobileNo1"
                                            value={formData.MobileNo1}
                                            onChange={handleChange}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>Mobile #2</strong>
                                          </label>
                                          <input
                                            type="number"
                                            value={formData.MobileNo2}
                                            onChange={handleChange}
                                            name="MobileNo2"
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>Phone #1</strong>
                                          </label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={formData.PhoneNo1}
                                            onChange={handleChange}
                                            id="PhoneNo1"
                                            name="PhoneNo1"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>Phone #2</strong>
                                          </label>
                                          <input
                                            type="number"
                                            name="PhoneNo2"
                                            onChange={handleChange}
                                            value={formData.PhoneNo2}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>Fax No.</strong>
                                          </label>
                                          <input
                                            type="number"
                                            name="FaxNo"
                                            onChange={handleChange}
                                            value={formData.FaxNo}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>Email</strong>
                                          </label>
                                          <input
                                            type="email"
                                            name="Email"
                                            onChange={handleChange}
                                            value={formData.Email}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>Email(Account)</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="Email_account"
                                            onChange={handleChange}
                                            value={formData.Email_account}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>Website</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="Website"
                                            onChange={handleChange}
                                            value={formData.Website}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* grid two */}
                              <div className="col-md-6 flex-col mt-1">
                                <div class="card">
                                  <div className="card-body">
                                    <div class="row">
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>CIN</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="CIN"
                                            onChange={handleChange}
                                            value={formData.CIN}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>PAN</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="PAN"
                                            onChange={handleChange}
                                            value={formData.PAN}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-6">
                                        <div class="form-group">
                                          <label className="col-form-label lbl me-3">
                                            <strong>TAN</strong>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            onChange={handleChange}
                                            value={formData.TAN}
                                            name="TAN"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>GSTIN/UIN</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="GSTNo"
                                            onChange={handleChange}
                                            value={formData.GSTNo}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>GST Date</strong>
                                          </label>
                                          <CustomDatePicker
                                            name="GSTEffectiveDate"
                                            handleChange={handleChange}
                                            value={formData.GSTEffectiveDate}
                                            placeholderText="GST Date"
                                          ></CustomDatePicker>
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>VAT/TIN</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="MVAT"
                                            onChange={handleChange}
                                            value={formData.MVAT}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>CST</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="CST"
                                            onChange={handleChange}
                                            value={formData.CST}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>Service Tax No.</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="ServiceTaxNo"
                                            onChange={handleChange}
                                            value={formData.ServiceTaxNo}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>LBT</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="LBT"
                                            onChange={handleChange}
                                            value={formData.LBT}
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-6">
                                        <div className="form-group">
                                          <label className="col-form-label lbl me-2">
                                            <strong>PTRC</strong>
                                          </label>
                                          <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="text-end mt-2 me-3">
              <Link to="/branchmastertable" className="custom-btn me-2">
                Cancel
              </Link>
              <button type="submit" className="custom-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditBranchMaster;
